export const PROSPECTING_TABS = {
  company: 'company',
  employees: 'employees',
};
